// extracted by mini-css-extract-plugin
export default {"container":"FaqPage_container__Ls07g"};